import { FunctionComponent, useContext, useEffect } from 'react';
import { counterTrigger } from 'Tools/counters';
import { AddPetContext } from 'Src/components/AddPet/AddPet';
import Text from '@media-ui/core/src/components/Text';
import Item from './FourthStepItem';
import Suit from './suit.svg';
import * as s from './FourthStep.css';
const FourthStep: FunctionComponent = () => {
    const addPetContext = useContext(AddPetContext);
    const isPetsshop = addPetContext?.isPetsshop;
    useEffect(() => {
        counterTrigger('addPetWindowFourthStep');
    });
    return (<section className={s.root}>
      {isPetsshop && (<Text className={s.petsshopText}>
          Промокод отправлен на указанный электронный адрес.
        </Text>)}
      {!isPetsshop && (<Item link="https://www.svoydoctor.ru/vladeltsam/uslugi/check-up-2024" icon={<Suit />} title="Ветеринар онлайн" subtitle="Вам доступны консультации ветеринара и кинолога!"></Item>)}
    </section>);
};
export default FourthStep;
